import { ExternalMessageInboxSettingsContainerState } from "@/Communications/Components/ExternalCommunications/ExternalMessageInboxSettingsContainer";

class ExternalMessageInboxSearchSettings {
    public IsAllSharedWithChecked: boolean;
    public SharedWithContactFaceIds: string[];
    public SelectedPageSizeOption: number;

    public static fromModel(model: ExternalMessageInboxSettingsContainerState): ExternalMessageInboxSearchSettings {
        const settings = new ExternalMessageInboxSearchSettings();
        settings.IsAllSharedWithChecked = model.isAllSharedWithChecked;
        settings.SharedWithContactFaceIds = model.sharedWithList.filter(x => x.Checked).map(x => x.ContactFacetId);
        settings.SelectedPageSizeOption = model.selectedPageSizeOption;

        return settings;
    }
}

export { ExternalMessageInboxSearchSettings };
